
import { TurboModuleRegistry } from "react-native";
import { getUIRuntimeHolder } from "react-native-worklets";
function getSyncStateInstaller() {
  var module = TurboModuleRegistry.get("OneNativeSyncState");
  if (!module) return null;
  return {
    install: function install() {
      var globals = globalThis;
      globals.__UI_WORKLET_RUNTIME_HOLDER = getUIRuntimeHolder();
      try {
        return module.install();
      } finally {
        delete globals.__UI_WORKLET_RUNTIME_HOLDER;
      }
    }
  };
}
export {
  getSyncStateInstaller
};
//# sourceMappingURL=syncInstaller.native.js.map
